import React from "react"
import PropTypes from "prop-types"

const CheckIcon = ({ style }) => (
  <svg viewBox="0 0 10 10" style={style}>
    <path d="M4.138 7.559L1.002 5.277 0 6.491 4.4 10 10 .818 8.7 0z" />
  </svg>
)

CheckIcon.propTypes = {
  style: PropTypes.object
}

export default CheckIcon



// WEBPACK FOOTER //
// ./src/components/icons/check-icon.jsx